import { Component, Inject } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DeviceDetectorService } from "ngx-device-detector";
import { AbstractBiditComponent } from "../../../shared/controls/abstract.bidit.component";
import { CustomerImport } from "../../../shared/models/customer.import.interface";
import { CustomerType } from "../../../shared/models/customer.type.interface";
import { Office } from "../../../shared/models/office.interface";
import { PaymentTerm } from "../../../shared/models/payment.term.interface";
import { PaymentType } from "../../../shared/models/payment.type.interface";
import { User } from "../../../shared/models/user.interface";
import { CustomerService } from "../../services/customer.service";

export interface ImportEditData {
  customer: CustomerImport;
  offices: Office[];
  paymentTerms: PaymentTerm[];
  paymentTypes: PaymentType[];
  customerTypes: CustomerType[];
  salespersons: User[];
}

@Component({
  selector: 'app-import-dialog',
  templateUrl: './import-edit.dialog.html',
  styleUrls: ['./import-edit.dialog.scss']
})
export class ImportEditDialog extends AbstractBiditComponent {
  
  constructor(
    protected customerService: CustomerService,
    deviceDetectorService: DeviceDetectorService,
    public dialogRef: MatDialogRef<ImportEditDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ImportEditData) {
    super(deviceDetectorService);
  }

  updateImport(importForm: NgForm) {
    if (!importForm.valid) return;

    // POST to server
    this.customerService.updateCustomerImport(this.data.customer.customerImport_ID, this.data.customer)
      .subscribe({
          next: (resp) => {
          this.dialogRef.close(true);
        },
        error: (error: string) => {
          this.isRequesting = false;
          this.onError(error);
        }});

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
